/*
 * @Author: your name
 * @Date: 2021-05-17 09:29:53
 * @LastEditTime: 2022-04-11 16:23:29
 * @LastEditors: Smart Chow
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/apps/appsModuleTable.js
 */
import sample_module from './modules/00_sample/moduleDefine'
import qc_plan from './modules/qc-plan/moduleDefine'
import qc_check from './modules/qc-check/moduleDefine'
import qc_rectification from './modules/qc-rectification/moduleDefine'
import qc_qualityImprovement from './modules/qc-qualityImprovement/moduleDefine'
import qc_workBench from './modules/qc-workBench/moduleDefine'
import qc_systemSetting from './modules/qc-systemSetting/moduleDefine'
import qc_overtimeAudit from './modules/qc-overtime-manage/moduleDefine'

const allModules = [
  sample_module,
  qc_plan,
  qc_check,
  qc_rectification,
  qc_qualityImprovement,
  qc_workBench,
  qc_systemSetting,
  qc_overtimeAudit
]
export default allModules
